import { useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import { REVIEWS } from "@/data/site";

export default function ReviewsSlider() {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: "start" });
  const [selected, setSelected] = useState(0);
  const [snaps, setSnaps] = useState([]);

  useEffect(() => {
    if (!emblaApi) return;
    setSnaps(emblaApi.scrollSnapList());
    const onSelect = () => setSelected(emblaApi.selectedScrollSnap());
    emblaApi.on("select", onSelect);
    onSelect();
    const timer = setInterval(() => emblaApi.scrollNext(), 4000);
    return () => {
      clearInterval(timer);
      emblaApi.off("select", onSelect);
    };
  }, [emblaApi]);

  return (
    <div data-testid="reviews-slider">
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex">
          {REVIEWS.map((r, i) => (
            <div key={r.name} className="min-w-0 flex-[0_0_100%] px-3 sm:flex-[0_0_50%] lg:flex-[0_0_33.3333%]">
              <figure data-testid={`review-card-${i}`} className="gold-ring gold-ring-hover flex h-full flex-col rounded-2xl bg-coal p-7">
                <div className="flex gap-1" aria-label={`${r.rating} out of 5 stars`}>
                  {Array.from({ length: r.rating }).map((_, s) => (
                    <Star key={s} size={15} className="fill-gold text-gold" />
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-stone-300">“{r.quote}”</blockquote>
                <figcaption className="mt-5 text-xs text-stone-500">
                  <span className="block font-serif-display text-lg text-cream">{r.name}</span>
                  {r.role}
                </figcaption>
              </figure>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-9 flex items-center justify-center gap-6">
        <button
          data-testid="reviews-prev"
          aria-label="Previous reviews"
          onClick={() => emblaApi?.scrollPrev()}
          className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/30 text-gold transition-all duration-300 hover:bg-gold hover:text-stone-950 active:scale-95"
        >
          <ChevronLeft size={18} />
        </button>
        <div className="flex gap-2">
          {snaps.map((_, i) => (
            <button
              key={i}
              data-testid={`reviews-dot-${i}`}
              aria-label={`Go to review slide ${i + 1}`}
              onClick={() => emblaApi?.scrollTo(i)}
              className={`h-1.5 rounded-full transition-all duration-500 ${i === selected ? "w-8 bg-gold" : "w-3 bg-stone-600 hover:bg-stone-500"}`}
            />
          ))}
        </div>
        <button
          data-testid="reviews-next"
          aria-label="Next reviews"
          onClick={() => emblaApi?.scrollNext()}
          className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/30 text-gold transition-all duration-300 hover:bg-gold hover:text-stone-950 active:scale-95"
        >
          <ChevronRight size={18} />
        </button>
      </div>
    </div>
  );
}
